const $ = require("jquery");

(function () {
    const $header = $(".Header");
    const $menu = $("[data-navigation]");
    const $menuOpen = $("[data-navigation-toggler]");
    const $menuClose = $("[data-navigation-close]");
    const $expandToggler = $menu.find("[data-expand-toggle]");
    const $overlay = $("[data-navigation-dropdown-overlay]");
    const $html = $("body");

    $menuOpen.on('click', function (e) {
        e.preventDefault();
        $html.toggleClass("-preventscroll")
        $menu.toggleClass("open");
        $overlay.show("fast");
    });

    $menuClose.on("click", closeMenu);

    $expandToggler.on("click", function (e) {
        e.preventDefault();
        $(this).find(".Icon").toggleClass("-open");
        $(this).parent().toggleClass("-expanded");
        $(this).parent().find(".Nav-submenu").toggleClass("-expanded");
    });

    $overlay.on("click", closeMenu);

    function closeMenu(e) {
        e.preventDefault();
        $overlay.hide("fast");
        $html.toggleClass("-preventscroll")
        $menu.toggleClass("open");
    }

    //Init
    var prevScrollpos = window.pageYOffset;
    if (prevScrollpos > 0) {
        $header.addClass("-solid");
    }

    window.onscroll = function () {
        const currentScrollPos = window.pageYOffset;

        if (currentScrollPos > 0) {
            $header.addClass("-solid");
        }
        else {
            $header.removeClass("-solid");
        }

        if (prevScrollpos > currentScrollPos) {
            $header.removeClass("-hide")
        } else {
            $header.addClass("-hide")
        }

        prevScrollpos = currentScrollPos;
    }
})();